import React from 'react';

// SVG-based digital badge renderer
const BADGE_TYPES = {
  skill: {
    gradient: ['#0EA5E9', '#3B82F6'],
    icon: '⚡',
    ring: '#DBEAFE',
  },
  achievement: {
    gradient: ['#F59E0B', '#EF4444'],
    icon: '🏆',
    ring: '#FEF3C7',
  },
  completion: {
    gradient: ['#10B981', '#059669'],
    icon: '✅',
    ring: '#D1FAE5',
  },
  excellence: {
    gradient: ['#8B5CF6', '#EC4899'],
    icon: '⭐',
    ring: '#EDE9FE',
  },
};

export default function Badge({ type = 'skill', label, sublabel, size = 80 }) {
  const cfg = BADGE_TYPES[type] || BADGE_TYPES.skill;
  const r = size / 2;
  const innerR = r * 0.78;

  return (
    <div className="flex flex-col items-center gap-2 group cursor-default">
      <div className="relative" style={{ width: size, height: size }}>
        <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
          <defs>
            <linearGradient id={`bg-${type}`} x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor={cfg.gradient[0]} />
              <stop offset="100%" stopColor={cfg.gradient[1]} />
            </linearGradient>
          </defs>
          {/* Outer ring */}
          <circle cx={r} cy={r} r={r - 1} fill={cfg.ring} />
          {/* Badge body */}
          <circle cx={r} cy={r} r={innerR} fill={`url(#bg-${type})`} />
          {/* Inner glow */}
          <circle cx={r} cy={r} r={innerR * 0.85} fill="rgba(255,255,255,0.15)" />
        </svg>
        <div
          className="absolute inset-0 flex items-center justify-center text-2xl group-hover:scale-110 transition-transform duration-300"
          style={{ fontSize: size * 0.32 }}
        >
          {cfg.icon}
        </div>
      </div>
      {label && (
        <div className="text-center">
          <div className="text-[11px] font-black text-slate-800 leading-tight">{label}</div>
          {sublabel && <div className="text-[9px] text-slate-400 font-bold uppercase tracking-widest mt-0.5">{sublabel}</div>}
        </div>
      )}
    </div>
  );
}
